import {
  getFunctions,
  httpsCallable,
} from 'firebase/functions'

import app from 'config/firebase'

const functions = getFunctions(app)

export const useProvideFunctions = () => {
  const updateUserEmail = async (data) => {
    const updateUserEmailFunction = httpsCallable(functions, 'updateUserEmail')
    const result = await updateUserEmailFunction(data)
    return result.data
  }

  const createUser = async (data) => {
    const createUserRoleFunction = httpsCallable(functions, 'createUserRole')
    const result = await createUserRoleFunction(data)
    return result.data
  }

  const deleteProfile = async (data) => {
    const deleteUserProfileFunction = httpsCallable(functions, 'deleteUserProfile')
    const result = await deleteUserProfileFunction(data)
    return result.data
  }

  return {
    createUser,
    deleteProfile,
    updateUserEmail
  }
}